/*eslint-disable piggyback/no-restricted-global-extend*/

import {logSubscriptionEvent} from '../../slices/planSlice';
import store from '../../store';

export class PaddleService {
	constructor() {
		this.initialized = false;
		this.eventListener = null;
	}

	loadScript(src) {
		return new Promise((resolve, reject) => {
			// Check if script already exists
			if (document.querySelector(`script[src="${src}"]`)) {
				resolve();
				return;
			}
			const script = document.createElement('script');
			script.src = src;
			script.onload = () => resolve();
			script.onerror = (error) => reject(new Error(`Failed to load script: ${src}`));
			document.head.appendChild(script);
		});
	}

	async loadPaddleScript() {
		if (!window.Paddle) {
			try {
				await this.loadScript('https://cdn.paddle.com/paddle/v2/paddle.js');
				return true;
			} catch (error) {
				console.error('Failed to load Paddle.js:', error);
				return false;
			}
		}
		return true; // Already loaded
	}

	async initialize(token, lang, externalCallback = null) {
		if (this.initialized) return;
		this.eventListener = externalCallback;
		const isLoaded = await this.loadPaddleScript();
		if (isLoaded && token) {
			window.Paddle.Environment.set('sandbox');
			window.Paddle.Initialize({
				token: token,
				checkout: {
					settings: {
						showAddTaxId: true,
						displayMode: 'overlay',
						theme: 'light',
						locale: lang,
						allowedPaymentMethods: ['apple_pay', 'google_pay', 'card'],
					},
				},
				eventCallback: (ev) => {
					this.handlePaddleEvent(ev);
				},
			});
			this.initialized = true;
		}
	}

	openCheckout(priceId, customerEmail, customData) {
		if (window.Paddle) {
			window.Paddle.Checkout.open({
				items: [
					{
						priceId: priceId,
						quantity: 1,
					},
				],
				customer: {
					email: customerEmail,
				},
				customData: customData,
			});
			return true;
		}
		return false;
	}

	closeCheckout() {
		if (window.Paddle) {
			window.Paddle.Checkout.close();
		}
	}

	handlePaddleEvent(ev) {
		const listenTo = [
			'checkout.completed',
			'checkout.payment.failed',
			'checkout.warning',
			'checkout.error',
			'checkout.closed',
		];
		if (listenTo.includes(ev.name)) {
			this.eventListener(ev);
			if (ev.name === 'checkout.completed') {
				this.closeCheckout();
			}
			store.dispatch(logSubscriptionEvent(ev));
		}
	}
}

const paddleService = new PaddleService();
export default paddleService;
